module.exports = __webpack_public_path__ + "img/carrousel-2.ab7a9c5e.jpg";